<template>
    <v-combobox
        ref="combobox_2"
        v-model="hospClin"
        :readonly="disableElementsReq"
        :disabled="loading.req.hospital || loading.req.doctor"
        clearable
        prefix="DR."
        color="teal"
        label="Full Name of Doctor"
        :items="getReqDoctors"
        item-text="doc_name"
        return-object
        autocomplete="nope"
        :loading="loading.req.hospital || loading.req.doctor"
        @change="handleChangeReqHospClinDoctor($event)"
    >
        <template #item="{ item }">
            <v-list-item-content>
                <v-list-item-title style="color: black;">
                    {{ item.doc_name }}
                </v-list-item-title>
                <v-list-item-subtitle style="font-size: 12px">
                    {{
                        [
                            item.doc_specialization_1,
                            item.doc_specialization_2,
                            item.doc_specialization_3
                        ]
                            .filter(Boolean)
                            .join(' • ')
                    }}
                </v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-combobox>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['disableElementsReq', 'req', 'loading'],
    data: ()=>({
        hospClin: null
    }),
    computed: {
        ...mapGetters(['getReqDoctors'])
    },
    watch: {
        getReqDoctors() {
            this.loading.req.doctor = false
        },
        'req.hospClinDoctor': {
            handler(newVal) {
                this.hospClin = newVal
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        handleChangeReqHospClinDoctor(value) {
            this.req.hospClinDoctor = value && value.doc_name
            this.req.hospClinDoctorCode = value && value.doc_id
        }
    }
}
</script>
